export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}; 
/**
 * payment_date é salvo como meia-noite UTC (date-only) e a API devolve "...T00:00:00.000000Z".
 * Converter para o fuso local mostra o dia anterior (31/08 21:00), então nesse caso
 * exibe só a data gravada, sem conversão. Com horário real, formata no fuso local.
 */
export const formatPaymentDate = (value?: string | null): string => {
  if (!value) return "-";

  const dateOnly = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ]00:00:00(?:\.0+)?Z?)?$/);
  if (dateOnly) {
    return `${dateOnly[3]}/${dateOnly[2]}/${dateOnly[1]}`;
  }

  const date = new Date(value);
  if (isNaN(date.getTime())) return value;

  return date.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
